import {
  readProjectFromCache,
  removeFromStorageItemsList,
  updateProjectListCounts,
} from '@sketch/modules-common'
import { ProjectCacheOperation } from '../operations/useProjectSubscriptions/utils'

export const handleProjectDeletedPermanently = (
  params: ProjectCacheOperation
) => {
  const { cache, identifier } = params

  const previousProject = readProjectFromCache(cache, identifier)

  // Remove from storageItems so nested folders remain in sync after permanent delete
  removeFromStorageItemsList({
    cache,
    target: { __typename: 'Project', identifier },
  })

  if (previousProject?.parentProjectIdentifier) {
    updateProjectListCounts(
      cache,
      previousProject.parentProjectIdentifier,
      project => {
        project.nestedProjectsCount--
      }
    )
  }
}
